const viewports = {
  MOBILE: 767,
  TABLET: 1024,
  DESKTOP: 1025,
};

export default viewports;
